/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import VpFiberNavBar from '../../../layouts/vp-fiber/VpFiberNavBar';
import OverviewBody from '../super-admin/overview/overview/OverviewBody';

const VpFiberOverview = () => {
    const firstName = sessionStorage.getItem('firstName');

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <VpFiberNavBar currentPage="Overview" position={firstName} />
        <OverviewBody />
      </main>
    </div>
  );
};

export default VpFiberOverview;
